module.exports = __webpack_public_path__ + "img/LoneDruid.e2afd1b0.png";